import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, UseShippingAddress } from './types'

export const initialState: Slice = {}

interface ActionData {
  cartId: string
  value: boolean
}

const getSlice = (slice: UseShippingAddress): UseShippingAddress => {
  return slice ?? {}
}

const slice = createSlice({
  name: 'quote/useShippingAddress',
  initialState,
  reducers: {
    setUseShippingAddress (state, action: PayloadAction<ActionData>) {
      const { cartId, value } = action.payload
      const slice = getSlice(state[cartId])
      slice.value = value
      state[cartId] = slice
    }
  }
})

export const reducer = slice.reducer

export const { setUseShippingAddress } = slice.actions
